import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import axios from 'axios';

import {
  SELECT_SUBJECT,
  CREATE_REWARD,
  FETCH_REWARDS,
  DELETE_REWARD,
  EDIT_REWARD
} from '../actions/types';

import {
  replaceRewardsInStore,
  addRewardToStore,
  setStatus,
  deleteRewardFromStore,
  updateRewardInStore,
} from '../actions';

import { STATUS } from '../constants';

export default function* transactionSaga() {
  yield all([
    takeLatest( SELECT_SUBJECT, fetchRewards),
    takeLatest( FETCH_REWARDS,  fetchRewards),
    takeLatest( CREATE_REWARD,  createReward),
    takeLatest( DELETE_REWARD,  deleteReward),
    takeLatest( EDIT_REWARD,    editReward),
  ])
}

const demoRewards = {
  1 : {
    subject_id : 2,
    description : "+30 minutes of iPad time",
    points : 10,
    reward_id : 1,
  },
}

function* fetchRewards(action) {

  try {

    yield put( replaceRewardsInStore(demoRewards) );
  }
  catch (e) {
    yield put( setStatus({type:STATUS.error, message: 'Could not fetch rewards'}));
  }

}


function* createReward(action) {

  try {
    const state = yield select();
    const nextRewardID = Math.max(0, ...Object.keys(state.rewards)) + 1;
    const reward       = { ...action.payload, reward_id : nextRewardID };
console.log("NEW REWARD : ", reward, nextRewardID, state.rewards);
    yield put( addRewardToStore(reward) );
    yield put( setStatus({type:STATUS.success, message: 'Successfully added reward'}));
  }
  catch (e) {
    yield put( setStatus({type:STATUS.error, message: 'Could not add reward'}));
  }

}

function* deleteReward(action) {

  try {
    const { reward_id } = action.payload;

    yield put( deleteRewardFromStore(reward_id) );
    yield put( setStatus({type:STATUS.success, message: 'Successfully deleted reward'}));
  }
  catch (e) {
    yield put( setStatus({type:STATUS.error, message: 'Could not delete reward'}));
  }

}

function* editReward(action) {

  try {
    const reward = action.payload;

    yield put( updateRewardInStore(reward) );
    yield put( setStatus({type:STATUS.success, message: 'Successfully updated reward'}));
  }
  catch (e) {
    yield put( setStatus({type:STATUS.error, message: 'Could not update reward'}));
  }

}
